import styled from 'styled-components';

export const TabListSticky = styled.div`
  width: 100%;

  position: sticky;
  top: 0;
  background-color: #181818;
  z-index: 1;

  display: flex;
  align-items: center;

  padding: 10px 20px;
`;

export const TabList = styled.div`
  display: flex;
  align-items: center;

  font-size: 20px;
  font-weight: 600;
  color: #c9c7d1;
  gap: 12px;
  row-gap: 4px;
  width: 100%;
  height: 42px;
  background-color: var(--color-background);
`;

export const TabItem = styled.div`
  position: relative;

  color: #c9c7d1;
  background: none !important;
  ${({ theme }) => theme.typography('$body_01')};
`;
